
export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
  },
  // {
  //   url: "/slider",
  //   name: "Slider",
  //   slug: "slider",
  //   icon: "ImageIcon",
  // },
  {
    url: "/stories",
    name: "Stories",
    slug: "stories",
    icon: "ActivityIcon",
  },
  {
    url: "/reels",
    name: "Reels",
    slug: "reels",
    icon: "VideoIcon",
  },
  {
    url: "/movies",
    name: "Movies & Series",
    slug: "movies",
    icon: "FilmIcon",
  },
  // {
  //   url: "/videos",
  //   name: "Videos",
  //   slug: "videos",
  //   icon: "VideoIcon",
  // },
  // {
  //   url: "/subtitles",
  //   name: "Subtitles",
  //   slug: "subtitles",
  //   icon: "TypeIcon",
  // },
  {
    url: "/genres",
    name: "Genres",
    slug: "genres",
    icon: "HashIcon",
  },
  {
    url: "/languages",
    name: "Languages",
    slug: "languages",
    icon: "GlobeIcon",
  },
  {
    url: "/groups",
    name: "Groups",
    slug: "groups",
    icon: "BoxIcon",
  },
  {
    url: "/collections",
    name: "Collections",
    slug: "collections",
    icon: "PackageIcon",
  },
  // {
  //   url: "/filters",
  //   name: "Filters",
  //   slug: "actors",
  //   icon: "ScissorsIcon",
  // },
  {
    url: "/cast",
    name: "Actors & staff",
    slug: "cast",
    icon: "SmileIcon",
  },
  {
    url: "/comments",
    name: "Comments",
    slug: "comments",
    icon: "MessageCircleIcon",
  },
  {
    url: "/notifications",
    name: "Notifications",
    slug: "notifications",
    icon: "BellIcon",
  },
  {
    url: "/tv",
    name: "Tv Section",
    slug: "tv",
    icon: "TvIcon",
  },
  {
    url: "/reports",
    name: "Reports",
    slug: "reports",
    icon: "FlagIcon",
  },
  // {
  //   url: "/subscribes",
  //   name: "Subscribes",
  //   slug: "subscribes",
  //   icon: "BellIcon",
  // },
  // {
  //   url: "/users",
  //   name: "Users",
  //   slug: "users",
  //   icon: "UsersIcon",
  // },
  // {
  //   url: "/settings",
  //   name: "Settings",
  //   slug: "settings",
  //   icon: "SettingsIcon",
  // },

  // {
  //   url: "/trash",
  //   name: "Trash",
  //   slug: "trash",
  //   icon: "TrashIcon",
  // },
]
